export default __webpack_public_path__ + "static/media/sign-out.d69fdb6d.svg";